import Panel from 'Components/Panel';
import SimpleList from 'Components/SimpleList';
import Table from 'Components/SimpleTable';
import React from 'react';
import { Link } from 'react-router';
import { unixToDate } from 'utils/date';
import { FOREVER_TIMESTAMP } from 'utils/ui/constants';

const indicatorProperties = model => [
    { label: 'ID', content: model.id },
    { label: 'Name', content: model.name },
    { label: 'Description', content: model.description || '-' },
    { label: 'Ignore Status?', content: model.ignore_status ? 'Yes' : 'No' },
    //{ label: 'Status', content: <span style={{ color: statusToColor(model.status) }}>{model.status}</span> },
    { label: 'Current Device', content: model.device_id ? <Link to={`/devices/${model.device_id}`}>{model.device_name}</Link> : '-' },
    { label: 'Site', content: model.site_name },
    { label: 'Kind', content: model.kind_name },
    { label: 'Min Value', content: model.min_value },
    { label: 'Max Value', content: model.max_value },
    { label: 'Creation', content: `${model.creator_name} @ ${unixToDate(model.created_at)}` },
    { label: 'Update', content: `${model.updater_name} @ ${unixToDate(model.updated_at)}` }
];

const historyProperties = [
    { label: 'ID', dataKey: 'id' },
    { label: 'Ratio', dataKey: 'ratio' },
    { label: 'Min Value', dataKey: 'min_value' },
    { label: 'Max Value', dataKey: 'max_value' },
    { label: 'Started at', dataKey: 'started_at' },
    { label: 'Ended at', dataKey: 'ended_at' }
];

const generateHistoryRows = buckets => buckets.map(bucket => ({
    ended_at: bucket.indicator_finish_at && bucket.indicator_finish_at !== FOREVER_TIMESTAMP ? unixToDate(bucket.indicator_finish_at) : '-',
    id: bucket.id,
    min_value: bucket.min_value,
    max_value: bucket.max_value,
    ratio: bucket.ratio,
    started_at: unixToDate(bucket.indicator_start_at)
}));

const Info = props => {
    const { buckets, model } = props;

    const indicatorAttributes = indicatorProperties(model);
    const historyRows = generateHistoryRows(buckets);

    return (
        <React.Fragment>
            <div id="properties" style={{ margin: '8px 0' }}>
                <Panel header="Indicator details">
                    <SimpleList content={indicatorAttributes}/>
                </Panel>
            </div>
            <div id="measurements" style={{ margin: '8px 0' }}>
                <Panel header="Measurements">
                    <Table columns={historyProperties} rows={historyRows}/>
                </Panel>
            </div>
        </React.Fragment>
    );
};

export default Info;
